var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1828_115391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.28684 23C6.61947 23 5.02038 22.3461 3.84137 21.182C2.66236 20.018 2 18.4393 2 16.7931C2 15.1469 2.66236 13.5682 3.84137 12.4042C5.02038 11.2401 6.61947 10.5862 8.28684 10.5862C8.68064 8.77542 9.83266 7.18411 11.4895 6.16236C12.3099 5.65645 13.2295 5.30558 14.1958 5.12981C15.1621 4.95404 16.1563 4.9568 17.1215 5.13793C18.0867 5.31906 19.004 5.67503 19.8211 6.18549C20.6382 6.69595 21.3391 7.35092 21.8837 8.113C22.4283 8.87509 22.806 9.72935 22.9952 10.627C23.1845 11.5247 23.1815 12.4482 22.9865 13.3448H24.3228C25.5633 13.3448 26.753 13.8534 27.6301 14.7588C28.5072 15.6641 29 16.8921 29 18.1724C29 19.4528 28.5072 20.6807 27.6301 21.586C26.753 22.4914 25.5633 23 24.3228 23H22.9865",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 18.75L15 15L18.75 18.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 16L15 26",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1828_115391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFileUpload);
export default __webpack_public_path__ + "static/media/ic_file_upload.3a9fc17de444bd7723a80bfc2bdc57a0.svg";
export { ForwardRef as ReactComponent };